import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { IconDotsVertical } from "@tabler/icons-react";
import { AppConstant } from "const";

const DepartmentListTable = ({ departmentList, onOpenAction, classes }) => {
  const { t: getLabel } = useTranslation();

  return (
    <Fragment>
      {departmentList && departmentList.length > 0 ? (
        departmentList.map(row => (
          <tr key={row.departmentId} style={{ backgroundColor: "var(--tblr-bg-surface-secondary)" }}>
            <td></td>
            <td
              className={classes.name}
              title={row.departmentName}
              style={{ fontSize: "0.85rem" }}
            >
              {row.departmentName}
            </td>
            <td style={{ fontSize: "0.85rem" }}>--</td>
            <td style={{ fontSize: "0.85rem" }}>{row.employeeNumber}</td>
            <td>
              <button
                className="btn btn-icon btn-ghost-secondary btn-sm"
                onClick={event => onOpenAction(event, row, AppConstant.COMPANY_MANAGEMENT_TYPE.department)}
              >
                <IconDotsVertical size={16} />
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr style={{ backgroundColor: "var(--tblr-bg-surface-secondary)" }}>
          <td></td>
          <td colSpan={4} style={{ fontSize: "0.85rem", textAlign: "left" }}>
            {getLabel("TXT_NO_DEPARTMENTS")}
          </td>
        </tr>
      )}
    </Fragment>
  );
};

export default DepartmentListTable;
